import styled, { css } from 'styled-components'
import { Card } from 'antd'
import { Container as _Container, IconButton, Grid } from '@libs/components'
import { color, padding, scrollbar, borderRadius, margin, screen } from '@libs/theme/mixins'

const Container = styled(_Container)`
	background: ${color(['gray', '900'])};
	position: relative;
`

const CarouselWrapper = styled.div`
	position: relative;
	margin-left: 180px;
	margin-right: 180px;

	.ant-carousel {
		max-height: 100vh;
	}

	.slick-track {
		display: flex !important;
	}

	.slick-slide {
		height: 100vh !important;

		> div {
			width: 100%;
			height: 100%;
		}
	}

	${screen.lte.xl`
		margin: 0;
	`}
`

const PanelHeader = styled(Grid.Row)`
	display: flex;
	align-items: center;
	min-height: auto !important;
	padding: 0 !important;

	.ant-col {
		&:nth-child(1) {
			width: calc(100% - 107px);
		}
		&:nth-child(2) {
			align-self: stretch;
		}
	}

	.ant-divider {
		height: 100%;
	}

	.ant-tabs-nav {
		margin: 0;

		&::before {
			display: none;
		}
	}
`

const MobileArrows = styled(_Container)`
	position: absolute;
	bottom: calc(100% + ${margin('xxs')});
	right: ${margin('xxs')};

	.ant-btn,
	.ant-typography {
		color: ${color('white')};
	}

	.ant-btn.ant-btn-text:hover span {
		text-decoration: none !important;
	}
`

const SlideWrapper = styled(_Container)`
	max-height: calc(100vh - 78px);
	height: 100%;

	img {
		object-fit: contain;
		width: 100%;
	}
`

const Logo = styled.img`
	position: absolute;
	width: 128px;
	top: 32px;
	left: 32px;
`

const SummaryWrapper = styled(Card)`
	position: absolute;
	top: 0;
	right: 0;
	height: auto !important;
`

const commonNavButtonStyled = css`
	position: absolute !important;
	top: calc(50% - 39px);
	transform: translateY(-50%);
	background: transparent !important;

	&:hover {
		svg {
			color: ${color('white')};
		}
	}

	svg {
		color: ${color('primary')};
		transition: color 0.5s;
	}
`

const PrevButton = styled(IconButton)`
	${commonNavButtonStyled};
	left: ${margin('xxl')};
`

const NextButton = styled(IconButton)`
	${commonNavButtonStyled};
	right: ${margin('xxl')};
`

const NavigationContainer = styled.div`
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
	width: 100%;

	.ant-collapse {
		border: none;
		background: transparent;
	}

	.ant-collapse-header {
		background: ${color(['gray', '000'])};
		border-radius: ${borderRadius('sm')} ${borderRadius('sm')} 0 0 !important;
		margin: auto;
		padding: ${padding('xs')} ${padding('md')} !important;
	}

	.ant-collapse-item {
		border-radius: 0 !important;
		display: flex;
		flex-direction: column;
	}

	.ant-collapse-content {
		border: none;
	}

	.ant-collapse-content-box {
		padding: ${padding('xs')};
	}

	.ant-row {
		overflow-x: auto;
		flex-wrap: nowrap;
		${scrollbar(true, undefined, true)};
		padding-bottom: ${padding('xxs')};

		${screen.lte.md`
			min-height: auto;
		`}
	}
`

const ThumbnailWrapper = styled.div<{ active: boolean }>`
	cursor: pointer;
	position: relative;
	border: 2px solid ${props => (props.active ? color('primary') : 'transparent')};
	padding: 1px;
	border-radius: ${borderRadius('sm')};
	min-height: 100px;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		border-radius: ${borderRadius('sm')};
	}
`

export default {
	Container,
	NextButton,
	PrevButton,
	SlideWrapper,
	CarouselWrapper,
	Logo,
	SummaryWrapper,
	NavigationContainer,
	ThumbnailWrapper,
	PanelHeader,
	MobileArrows,
}
